"use client";

import HeaderBackground from "@/components/ui/header-background";
import Breadcrumbs from "@/components/entities/breadcrumbs";
import TwoColumnsBlock from "@/components/ui/two-columns-block";
import { useTranslations } from "next-intl";
import { useCollectionPageData } from "../../hooks/useCollectionPageData";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const Header = () => {
  const t = useTranslations();
  const { collectionPage } = useCollectionPageData();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  if (!collectionPage.collectionPage || collectionPage.loading) return null;

  return (
    <>
      <HeaderBackground type="video" src={collectionPage.collectionPage.video} />
      <Container>
        <div className={S.headerWrapper}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <h1 className={S.title}>{t("collections")}</h1>
          <TwoColumnsBlock
            title={collectionPage.collectionPage.title}
            subtitle={collectionPage.collectionPage.description}
          />
        </div>
      </Container>
    </>
  );
};

export default Header;
